export class GeoLocation {
  latitude: number;
  longitude: number;
}
